import { RouterEnum } from '@interface/public';
import RE from '@module/regexp';

/**
 * 配置
 */
export default class Config {
  public static readonly Cookie = { // Cookie
    domain: RE.Format.IPV4.test(location.hostname) // 域名
      ? ''
      : location.hostname.split('.').slice(-2).join('.'),
    time: 24 * 7 // SSO保存时间（小时）
  };
  public static readonly Console = { // 控制台
    log: '/////-' // 日志
  };
  public static readonly Href = { // 链接
    ...(
      $ENV.isFormal
        ? { // 正式服
          sso: 'https://sso.galaxy-future.com', // SSO
          official: 'https://www.galaxy-future.com', // 官网
          store: 'https://apps.galaxy-future.com', // 云应用市场
          cloud: 'https://cloud.galaxy-future.com', // 云托管平台
          cloudDemo: 'https://ifs.galaxy-future.com', // 云托管平台（Demo）
          console: 'https://console.galaxy-future.com', // Console
          dtexpress: 'https://dtexpress.galaxy-future.com', // 数据物流
          activity: 'https://activity.galaxy-future.com', // Activity
          aiavatars:'https://aiavatars-monn34rc.apps.galaxy-future.com/', // AI互动数字人
        }
        : { // 测试服
          sso: 'http://172.16.16.182:30081', // SSO
          official: 'http://172.16.16.180:30080', // 官网
          store: 'https://apps.galaxy-future.com', // 云应用市场
          cloud: 'http://172.16.16.180:30092', // 云托管平台
          cloudDemo: 'http://172.16.16.180:18080', // 云托管平台（Demo）
          console: 'http://172.16.16.180:32003', // Console
          dtexpress: 'http://172.16.16.180:32094', // 数据物流
          activity: 'http://172.16.16.180:30082',  // Activity
          aiavatars:'https://aiavatars-monn34rc.apps.galaxy-future.com/', // AI互动数字人
        }
    ),
    gss: 'https://gss.galaxy-future.com/#/cost/analysis', // GSS
    github: 'https://github.com/galaxy-future/infrapilot' // Github
  };
  // master_34 构建 GF_TYPE=34，原项目按正式 SSO/API 处理，不能与官网开发服账号混用。
  public static readonly DigitalHuman = {
    authorizationServer: !$ENV.isProduction ? '/digital-human-auth' : ($ENV.isFormal ? 'https://api.galaxy-future.com' : 'http://172.16.148.206:1828'),
    teamId: $ENV.isFormal ? '169172527963205416' : '170385404766225331',
    characterId: $ENV.isFormal ? '185564399128346605' : '213122692029639252',
    characterName: $ENV.isFormal ? '客服9527' : '李清照',
    // 入口只需公开待机素材，不依赖 init/media_detail；展开后以接口素材为准。
    idleVideo: $ENV.isFormal
      ? 'https://gcom-aibot-assets.galaxy-future.com/digital-human/builtin/characters/185564399128346605-8f5b34d738f82a3f8d116ef58674fb43@video_hd.webm?t=1792075870'
      : 'https://gcom-aibot-assets.galaxy-future.com/digital-human/user/170385404766225331/characters/213122692029639252-still-0.webm?t=1784708169',
    // 详情未加载时使用公开封面，避免为了入口图片提前请求init/media_detail。
    idleThumbnail: $ENV.isFormal
      ? 'https://gcom-aibot-assets.galaxy-future.com/digital-human/builtin/thumbnails/characters/185564399128346605-0.png?t=1792075870'
      : '',
    videoQuality: 'video_hd', // 原数字人枚举 Low，适用于客服小窗
    gatewayServer: !$ENV.isProduction ? '/digital-human' : ($ENV.isFormal ? 'https://aiavatars-monn34rc.apps.galaxy-future.com' : 'http://10.192.208.36:8099'),
    // 测试发布直连独立测试服务；其 CORS 未允许 x-device-env，信令正文仍保留 env。
    sendEnvHeader: !$ENV.isProduction || $ENV.isFormal,
    sso: 'https://sso.galaxy-future.com',
    api: 'https://api.galaxy-future.com',
    env: $ENV.isFormal ? '34' : 'test',
    audioSetting: { bitrate: 48000, denoise: 'no' as const, clear_voice: false, asr_provider: 'bytedance' as const }
  };
  public static readonly Template = { // 模板
    default: RouterEnum.Home, // 默认页面
    size: 'small', // 尺寸
    pagination: { // 分页
      pageSize: 10
    }
  };
}
